import { set } from 'lodash'
import { Observable } from 'rxjs'
import { filter, switchMap } from 'rxjs/operators'

import { User, Cache, DataStoreOptions } from '@skinsoft/types'
import { Proxy } from '@skinsoft/network'
import { AuthService } from '@skinsoft/auth'
import { DataStore } from '@skinsoft/data-store'

interface EntityDataStoreOptions extends DataStoreOptions {
    userScope?: boolean;
}

export abstract class EntityDataStore<T extends { id: string } = any, U = any, S extends { id: string } = T> extends DataStore<T, S> {
    public readonly featuredStates: U[] = [];
    public readonly historyStates: U[] = [];
    public readonly sortFields: string[] = [];
    public readonly entityName: string;

    constructor(entityName: string, typesForSearch?: string[], typesForSyncDown?: string[], proxy?: Proxy, cache?: Cache<T>, fragmentParser = response => (response._embedded ? response._embedded[entityName] : [])) {
        super(
            `/${entityName}`,
            typesForSearch,
            typesForSyncDown,
            fragmentParser, // for getAll
            proxy,
            cache,
        );
        this.entityName = entityName;
    }

    public fetchAll(options: EntityDataStoreOptions = {}): Observable<T[]> {
        const { userScope, ...otherOptions } = options;

        if (!userScope) {
            return super.fetchAll(otherOptions);
        }

        return AuthService.getInstance().user$.pipe(
            filter(u => u !== null),
            switchMap(user =>
                super.fetchAll(set(otherOptions, 'query.affectedUser', (user as User).id)),
            ),
        );
    }
}
